import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { StatusBadge } from "@/components/StatusBadge";
import { ROOM_STATUS } from "@/lib/constants";
import { yen, area } from "@/lib/format";
import { useLookups } from "@/context/LookupContext";
import { Loader2, DoorClosed } from "lucide-react";

export default function Vacancies() {
  const { nameOf } = useLookups();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/rooms").then(({ data }) => {
      setRooms(data.filter((r) => r.status === "vacant" || r.status === "recruiting"));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="animate-fade-in">
      <PageHeader title="空室一覧" subtitle="空室・募集中の部屋" />
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>
      ) : rooms.length === 0 ? (
        <div className="bg-white border border-border rounded-sm py-16 text-center text-muted-foreground">
          <DoorClosed className="w-10 h-10 mx-auto mb-3 text-gray-300" />空室はありません
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rooms.map((r) => (
            <div key={r.id} className="bg-white border border-border rounded-sm p-5 hover:border-brand/60 transition-colors" data-testid={`vacancy-${r.id}`}>
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="text-xs text-muted-foreground">{nameOf("properties", r.property_id)}</div>
                  <div className="font-display text-2xl font-medium">{r.room_number}</div>
                </div>
                <StatusBadge value={r.status} map={ROOM_STATUS} />
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <div><span className="text-muted-foreground text-xs block">間取り</span>{r.layout || "-"}</div>
                <div><span className="text-muted-foreground text-xs block">面積</span>{area(r.area)}</div>
                <div className="col-span-2"><span className="text-muted-foreground text-xs block">賃料</span><span className="font-display text-lg text-brand">{yen(r.rent)}</span> / 月</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
